import type { AuthUser } from './api'

export type Capability =
  'viewDashboard' | 'buyProxies' | 'viewInvoices' | 'manageUsers' | 'viewReferrals' | 'viewMarketing' | 'viewAccount' | 'viewNews' | 'viewSupport'

export function hasCapability(user: AuthUser | null, capability: Capability): boolean {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  switch (capability) {
    case 'manageUsers':
      return Boolean(user.is_reseller)
    case 'viewMarketing':
      return Boolean(user.is_marketer)
    case 'viewDashboard':
    case 'buyProxies':
      return !user.is_marketer
    default:
      return true
  }
}
